/**
 * Password validation utility
 * Matches backend validation requirements in zoommgr/validators.py
 *
 * Requirements:
 * - Minimum 12 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 * - At least one special character
 */

export const validatePassword = (password) => {
  if (!password) {
    return { isValid: false, error: 'Password is required' };
  }

  if (password.length < 12) {
    return { isValid: false, error: 'Password must be at least 12 characters long' };
  }

  if (!/[A-Z]/.test(password)) {
    return { isValid: false, error: 'Password must contain at least one uppercase letter' };
  }

  if (!/[a-z]/.test(password)) {
    return { isValid: false, error: 'Password must contain at least one lowercase letter' };
  }

  if (!/[0-9]/.test(password)) {
    return { isValid: false, error: 'Password must contain at least one number' };
  }

  if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?/\\`~]/.test(password)) {
    return { isValid: false, error: 'Password must contain at least one special character (!@#$%^&* etc.)' };
  }

  return { isValid: true, error: null };
};

/**
 * Password requirements help text
 */
export const PASSWORD_REQUIREMENTS = [
  'At least 12 characters',
  'One uppercase letter',
  'One lowercase letter',
  'One number',
  'One special character (!@#$%^&* etc.)'
];

/**
 * Get password strength indicator
 */
export const getPasswordStrength = (password) => {
  if (!password) return { strength: 'none', color: 'secondary', label: '' };

  let score = 0;
  if (password.length >= 12) score++;
  if (password.length >= 16) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[!@#$%^&*()_+\-=[\]{}|;:,.<>?/\\`~]/.test(password)) score++;

  if (score <= 2) return { strength: 'weak', color: 'danger', label: 'Weak' };
  if (score <= 4) return { strength: 'fair', color: 'warning', label: 'Fair' };
  if (score <= 5) return { strength: 'good', color: 'info', label: 'Good' };
  return { strength: 'strong', color: 'success', label: 'Strong' };
};
